import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import Image from "components/landing/image"
import Textarea from "components/landing/textarea"
import { to_currency } from "helpers/number"

const DiamondItem = ({ image, prices, ...rest }) => {
  const getText = (price) => {
    const { display_price, retail_price } = price || {}
    if (!display_price || !retail_price) {
      return ""
    }
    return `<span style='text-decoration: line-through'>${to_currency(
      retail_price
    )}</span> <span style='color: #C20101'>${to_currency(display_price)}</span>`
  }
  const labDiamond = prices?.find((item) => item.s1 === "04LABDIAM")
  const diamond = prices?.find((item) => item.s1 === "04DIAM")
  const info = {
    texts: [
      {
        style: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: "1.5",
          mb: 0,
        },
        text: "Lab Diamond",
        type: "title",
      },
      {
        style: {
          fontSize: 12,
          mb: { _: "4px", tablet: 1 },
        },
        text: getText(labDiamond),
        type: "description",
      },
      {
        style: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: "1.5",
          mb: 0,
        },
        text: "Diamond",
        type: "title",
      },
      {
        style: {
          fontSize: 12,
          mb: { _: 3, tablet: 1 },
        },
        text: getText(diamond),
        type: "description",
      },
    ],
  }

  return (
    <Box width="50%" {...rest}>
      <Image image={image} />
      <Textarea element={info} />
    </Box>
  )
}

DiamondItem.propTypes = {
  image: PropTypes.object,
  prices: PropTypes.arrayOf(PropTypes.object),
}

export default DiamondItem
